package com.mencanhealth.admin.model

import kotlinx.serialization.Serializable

@Serializable
enum class AppointmentType(val label: String, val durationMinutes: Int, val priceMXN: Int) {
    INITIAL("Consulta Inicial", 60, 250),
    FOLLOWUP("Consulta de Seguimiento", 30, 150),
    EXPRESS("Consulta Express Online", 20, 100)
}

@Serializable
enum class AppointmentModality(val label: String) {
    PRESENCIAL("Presencial en Puebla"),
    ONLINE("En línea (Google Meet)")
}

@Serializable
enum class AppointmentStatus(val label: String) {
    PENDING_PAYMENT("Pendiente de Pago"),
    CONFIRMED("Confirmada"),
    COMPLETED("Completada"),
    CANCELLED("Cancelada"),
    NO_SHOW("No Asistió")
}

@Serializable
enum class PaymentMethod(val label: String) {
    TRANSFER("Transferencia Bancaria"),
    CASH("Efectivo")
}

@Serializable
data class Appointment(
    val id: String = "",
    val patientName: String = "",
    val patientEmail: String = "",
    val patientWhatsApp: String = "",
    val appointmentType: String = AppointmentType.INITIAL.name,
    val modality: String = AppointmentModality.PRESENCIAL.name,
    val date: String = "",
    val timeSlot: String = "",
    val durationMinutes: Int = 60,
    val status: String = AppointmentStatus.PENDING_PAYMENT.name,
    val paymentMethod: String = PaymentMethod.TRANSFER.name,
    val paymentConfirmed: Boolean = false,
    val meetLink: String = "",
    val notes: String = "",
    val createdAt: Long = 0L,
    val confirmedAt: Long = 0L,
    val questionnaireResponses: String = ""
)

@Serializable
data class AvailabilityBlock(
    val id: String = "",
    val dayOfWeek: Int = -1,
    val specificDate: String = "",
    val startTime: String = "",
    val endTime: String = "",
    val slotDurationMinutes: Int = 30,
    val isRecurring: Boolean = false,
    val active: Boolean = true
)

@Serializable
data class TimeSlot(
    val time: String = "",
    val available: Boolean = true
)

